import actions from './actions'

export default {
  name: 'statistic',
  namespaced: true,
  actions
}